export const getTranslatedLabel = (object, activeLanguage) => {
  switch (activeLanguage) {
    case 'fr':
      return object.labelFr;
    case 'en':
      return object.labelEn;
    case 'es':
      return object.labelEs;
    default:
      return object.labelFr;
  }
}
export const getTranslatedDescription = (object, activeLanguage) => {
  switch (activeLanguage) {
    case 'fr':
      return object.descriptionFr;
    case 'en':
      return object.descriptionEn;
    case 'es':
      return object.descriptionEs;
    default:
      return object.descriptionFr;
  }
}
